import { AuthStore } from '@foxdcg/cpe-commerce-web';

//AuthStore saves userData (from jwt from BE) in a cookie
//These methods are for setting, updating, and pulling info from the cookie

//five years for epoch timestamps (milliseconds) = 1000ms * 60sec * 60min * 24hr * 365days * 5yrs = 157,680,000,000
const FIVE_YEARS = 157680000000;

//full user data including access token
export const getUser = () => AuthStore.getToken();

//just the accessToken in the userData jwt
export const getAccessToken = () => AuthStore.getAccessToken();

export const isNonAnonymousUser = () => AuthStore.isNonAnonymousUser();

export const getUserMvpdId = () => AuthStore.getMvpdId();

export const isAnonymousUser = () => AuthStore.isAnonymousUser();

export const isMvpdUser = () => AuthStore.isMvpdUser();

export const setUser = (user) => {
  // set idToken to empty string since it overflows the cookie
  user.idToken = '';
  AuthStore.setToken(user);
};

export const removeUser = () => AuthStore.removeToken();

export const configureAuthStore = ({ defaultConfig }) => {
  return AuthStore.configure({
    domain: defaultConfig.cookieDomain,
    preProd: defaultConfig.useAuthPreprodName,
    secure: false, // temporary setting it to false (will enable once CPEWEB team have migrated to new package for sso)
  }); // returns token if present
};

// set a new crossdomain token
export const updateName = async ({ firstName, lastName }) => {
  // replace existing token with udpated one
  const currentToken = getUser();
  // create new token
  const newToken = { ...currentToken, firstName, lastName };
  // update sso
  await setUser(newToken);
  return newToken;
};

export const updateRefreshToken = async ({ refreshToken, accessToken, accessTokenExpiration }) => {
  const currentToken = getUser();
  const expirations = getTokenExpirations(accessTokenExpiration);
  const newToken = { ...currentToken, refreshToken, accessToken, ...expirations };
  await setUser(newToken);
  return newToken;
};

/*
TODO: refactor out using this function, probably by no longer using the cpe-commerce-web library to manage the cookie

We receive a tokenExpiration field from the backend. This is the expiration time of the accessToken, after which a
request for a new refreshToken is needed.

The cpe-commerce-web library looks for the tokenExpiration field to determine when to delete the cookie.
We want the cookie to last a long time and not be deleted so soon.
So we're essentially renaming tokenExpiration from the BE to accessTokenExpiration for our use.
*/
export const getTokenExpirations = (accessTokenExpiration) => {
  if (!accessTokenExpiration) return {};
  return { accessTokenExpiration, tokenExpiration: accessTokenExpiration + FIVE_YEARS };
};
